import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "@/components/marketing/legal-page-layout";

const TERMS_SECTION_KEYS = [
    "acceptance",
    "useOfService",
    "accountSecurity",
    "intellectualProperty",
    "limitationOfLiability",
    "changes",
    "contact",
] as const;

const TERMS_LAST_UPDATED = "2025-03-05";

export function TermsPage() {
    const { t } = useTranslation("pages:legal");
    const lastUpdatedFormatted = new Date(TERMS_LAST_UPDATED).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <LegalPageLayout>
            <article className="space-y-10">
                <div>
                    <h1 className="text-3xl font-bold tracking-tight text-primary sm:text-4xl">
                        {t("terms.title")}
                    </h1>
                    <p className="mt-2 text-sm text-tertiary">
                        {t("lastUpdated")}: {lastUpdatedFormatted}
                    </p>
                </div>
                <div className="space-y-8">
                    {TERMS_SECTION_KEYS.map((key) => (
                        <section key={key} id={key}>
                            <h2 className="text-xl font-semibold text-primary mb-3">
                                {t(`terms.sections.${key}.title`)}
                            </h2>
                            <p className="text-sm text-tertiary leading-relaxed">
                                {t(`terms.sections.${key}.content`)}
                            </p>
                        </section>
                    ))}
                </div>
            </article>
        </LegalPageLayout>
    );
}
